import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Col, message, Row, Table, Upload } from "antd";
import { useState } from "react";
import { read as XLSXread, utils as XLSXutils, writeFile as XLSXwrite } from "xlsx";
import { ContentBox } from "../../components/layout/content";
import { LoginedLayout } from "../../components/layout/loginLayout";
import { HeaderTitle } from "../../components/styled-components";
import { PATCH } from "../../services";
import { UPDATE_TRACKING } from "../../services/path";

interface DataType {
  key: string;
  order_no: string;
  tracking_no: string;
}

const UploadtrackPage = () => {
  const [tableData, setTableData] = useState<DataType[]>([]);

  // Function to download Excel template
  const downloadTemplate = () => {
    const ws = XLSXutils.json_to_sheet([{ orderNumber: "", tracking: "" }]);
    const wb = XLSXutils.book_new();
    XLSXutils.book_append_sheet(wb, ws, "Template");
    XLSXwrite(wb, "template.xlsx");
  };

  // Function to handle file upload
  const handleUpload = (file: any) => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSXread(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSXutils.sheet_to_json(sheet);
      const formattedData = jsonData.map((row: any, index: number) => ({
        key: index.toString(),
        order_no: row.orderNumber.toString() || "",
        tracking_no: row.tracking.toString() || "",
      }));

      setTableData(formattedData);
    };

    reader.readAsArrayBuffer(file);
    return false;
  };

  // Function to submit and log data
  const handleSubmit = async () => {
    const submitData = {
      data: tableData.map(({ order_no, tracking_no }) => ({ order_no, tracking_no })),
    };

    try {
      const result = await PATCH(UPDATE_TRACKING, submitData);
      if (result) {
        message.success(`Upload สำเร็จ`);
      }
    } catch (error) {
      message.error(`พบข้อผิดพลาด`);
    }

    setTableData([]); // Clear the table data
  };

  // Define columns for the AntD Table
  const columns = [
    {
      title: "No",
      key: "no",
      render: (_: any, __: any, index: number) => index + 1, // Display row index + 1
    },
    {
      title: "Order Number",
      dataIndex: "order_no",
      key: "order_no",
    },
    {
      title: "Tracking",
      dataIndex: "tracking_no",
      key: "tracking_no",
    },
  ];

  return (
    <LoginedLayout>
      <ContentBox>
        <HeaderTitle>
          <h2>UpdateTracking</h2>
        </HeaderTitle>
        <Row gutter={10}>
          <Col span={6} style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
            <Button type="primary" icon={<DownloadOutlined />} onClick={downloadTemplate}>
              Download Template
            </Button>
            <Upload accept=".xlsx" beforeUpload={handleUpload} showUploadList={false}>
              <Button icon={<UploadOutlined />}>Upload Template</Button>
            </Upload>
          </Col>
        </Row>
        <Table dataSource={tableData} columns={columns} style={{ marginTop: 20 }} />
        <div
          id="Submit-uploadtrack"
          style={{ display: "flex", justifyContent: "center", paddingTop: "20px" }}
        >
          <Button type="primary" onClick={handleSubmit} disabled={tableData.length === 0}>
            Submit
          </Button>
        </div>
      </ContentBox>
    </LoginedLayout>
  );
};

export default UploadtrackPage;
